import { Dialog, Button, DialogTitle } from "@mui/material";
// import { useDispatch } from 'react-redux';
import { StyleSheet, css } from "aphrodite";
import { useAppDispatch } from "../../store/hooks";
import { logout } from "../../store/auth/auth-actions";
import { JSX } from "react";
import { useNavigate } from "react-router-dom";

// import { AppDispatch } from '../../store';

interface Props {
  open: boolean;
  toggle: () => void;
}

const LogoutModal = (props: Props): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log("sair");
    await dispatch(logout() as any);

    props.toggle();

    navigate("/"); // ou "/login"
  };

  return (
    <Dialog open={props.open} onClose={props.toggle}>
      <DialogTitle>Deseja realmente sair do sistema?</DialogTitle>
      <div className={css(styles.buttonContainer)}>
        <Button variant="outlined" color="success" onClick={handleLogout}>
          Sim
        </Button>{" "}
        <Button variant="outlined" color="error" onClick={props.toggle}>
          Cancelar
        </Button>
      </div>
    </Dialog>
  );
};

export default LogoutModal;

const styles = StyleSheet.create({
  container: {
    padding: 100,
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    marginBottom: "3%",
  },
});
